import { CustomAxiosRequestConfig, http } from '@/core/helpers/axiosHelper';

export class ReplacementMotiveService {
   async getReplacementMotives(tag: 'termination' | 'suspension') {
      const response = await http.get(`/replacement-motives`, {
         params: { tag },
         cancelable: false,
      } as CustomAxiosRequestConfig);
      return response.data?.data;
   }
}
